<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>SI-COT</title>
</head>

<body>


    <!--<div class="example-container" [class.example-is-mobile]="mobileQuery.matches" *ngIf="isLogged()">

        <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
            <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
                fixedTopGap="56" opened>
                <h3>SI-COT</h3>

                <button mat-menu-item (click)="goRichieste()">
                    <mat-icon>home</mat-icon>
                    <span>Richieste</span>
                </button>
                <button mat-menu-item>
                    <mat-icon>notifications</mat-icon>
                    <span>Notifiche</span>
                </button>
            </mat-sidenav>

            <mat-sidenav-content>
                <button mat-icon-button (click)="snav.toggle()"><mat-icon>menu</mat-icon></button>
                <router-outlet></router-outlet>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>



    <router-outlet *ngIf="!isLogged()"></router-outlet>-->

    <!-- <router-outlet></router-outlet> -->

    <ng-container *ngIf="!isAuthorized"></ng-container>

    <ng-container *ngIf="isAuthorized">
        <router-outlet></router-outlet>
    </ng-container>


</body>

</html>